import Call from '../Call.v2';
import {objToQs} from '../Utils';

const AdkReport = {
    get(type, filters, path = '') {
        return Call(`adk/report/${type}/${path}?${objToQs(filters)}`);
    },

    // getHourly(filters, path = '') {
    //     return Call(`bidder/networkPerformance/hourly/${path}?${objToQs(filters)}`);
    // },
};

export default AdkReport;



// WEBPACK FOOTER //
// ./src/services/API/components/AdkReport.js